import { isDevMode } from '@angular/core';
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { error } from "util";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";
import { CustomCookieService } from "../providers/mycookie.service";
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { CustomStorage } from "./Custom-storage.service";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Constant } from '../Constant'
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/catch';
import { ResponseType } from '@angular/http/src/enums';
@Injectable()
export class RestApiServices {
    // const = Constant
    commonurl: string = environment.commonurl;
    // commonurl :string = localStorage.setItem('http://120.138.9.165:8980/CDIServices/rest/orderprocessingservice/');
    //commonurl :string = 'http://120.138.9.165:8980/CDIServices/rest/orderprocessingservice/';
    login_data: Object;
    invoice_data: Object;
    //token: Object;
    customersync_data: Object;
    logOut_data: Object;
    db_data: Object;
    userid = 'staticuser';
    password = 's3cur1ty';
    prevSerach: any;
    prevSearch: string;


    orderItem: any = [];
    selectedOrderSource = new BehaviorSubject<any>(0);
    selectedOrderItem = this.selectedOrderSource.asObservable()

    categoryItem: any = [];
    selectedCategorySource = new BehaviorSubject<any>(0);
    selectedCategoryItem = this.selectedCategorySource.asObservable()
    searchTerm: string = '';
    //  timeout: number = 3000;
    timeout: number = 3000000;
    selectedproductsearch = new BehaviorSubject<any>(this.searchTerm);
    selectedsearchItem = this.selectedproductsearch.asObservable()
    constructor(private http: Http, private cookieService: CustomCookieService, private localStorage: CustomStorage) {
    }



    getLoginResponse(username, password, companyId) {
        return Observable.create((observer: Observer<any>) => {
            this.getLoginResponseData(username, password, companyId).subscribe(data => {
                //this.loginApi().subscribe(data => {
                let response = data.json();

                //this.cookieService.setCookieData('customer',JSON.stringify(response));
                this.localStorage.setItem(Constant.KEY_CUSTOMER, response).subscribe(result => {
                    observer.next(response);
                    observer.complete();
                });
            }, error => {
                observer.error("Login Error : " + error);
                observer.complete();
            });
        });
    }

    getPaymentApiConfig(cust_number:any) {
        return Observable.create((observer: Observer<any>) => {
            this.getPaymentApiConfigData(cust_number).subscribe(data => {
                //this.loginApi().subscribe(data => {
                let response = data.json();
                observer.next(response);
                observer.complete();
            }, error => {
                observer.error("Login Error : " + error);
                observer.complete();
            });
        });
    }
   
    getsuperLoginResponse(username, password, companyId) {
        return Observable.create((observer: Observer<any>) => {
            this.getsupervisorLoginResponseData(username, password, companyId).subscribe(data => {
                //this.loginApi().subscribe(data => {
                let response = data.json();             
                //this.cookieService.setCookieData('customer',JSON.stringify(response));
                this.localStorage.setItem(Constant.KEY_SUPERVISORLOGIN, response).subscribe(result => {
                    observer.next(response);
                    observer.complete();
                });
            }, error => {
                observer.error("Login Error : " + error);
                observer.complete();
            });
        });
    }


    public getLoginResponseData(username, password, companyId) {
        return Observable.create((observer: Observer<any>) => {
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            // headers.append("Access-Control-Allow-Methods", "GET, POST, PATCH, PUT, DELETE, OPTIONS");
            //headers.append("Access-Control-Allow-Headers", "Origin, Content-Type, X-Auth-Token, ");
            //headers.append("Access-Control-Expose-Headers", "Authorization");
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_ORIGIN, "*, Content-Type");
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_HEADERS, 'Origin, Content-Type, X-Auth-Token');
            //headers.append('Allow', 'GET, POST, PUT, DELETE, OPTIONS, HEAD');
            let options = new RequestOptions({
                headers: headers
            });
            let url = this.commonurl + "customerlogin";
            this.http.post(url, JSON.stringify({
                request: {
                    username: username,
                    password: password,
                    company_id: companyId,
                    user_type: "webuser",
                }
            }), options).timeout(this.timeout).subscribe(
                response => {
                    if (response != null) {
                        this.cookieService.setCookieData(Constant.KEY_USERNAME, username);
                        this.cookieService.setCookieData(Constant.KEY_TOKEN, response.json().response.data.token);
                        this.localStorage.setItem(Constant.KEY_LOGIN, response).subscribe(res => {
                            observer.next(response);
                            observer.complete();
                        });
                    }
                },
                error => {
                    observer.next(error);
                    observer.complete();
                },
                () => {
                });
        });
    }


    public getPaymentApiConfigData(cust_number:any) {
        return Observable.create((observer: Observer<any>) => {
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            // headers.append("Access-Control-Allow-Methods", "GET, POST, PATCH, PUT, DELETE, OPTIONS");
            //headers.append("Access-Control-Allow-Headers", "Origin, Content-Type, X-Auth-Token, ");
            //headers.append("Access-Control-Expose-Headers", "Authorization");
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_ORIGIN, "*, Content-Type");
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_HEADERS, 'Origin, Content-Type, X-Auth-Token');
            //headers.append('Allow', 'GET, POST, PUT, DELETE, OPTIONS, HEAD');
            let options = new RequestOptions({
                headers: headers
            });
            let url = this.commonurl + "getonlinepaymentaccount";
            this.http.post(url, JSON.stringify({
                request: {
                    custnumber: cust_number,
                }
            }), options).timeout(this.timeout).subscribe(
                response => {
                    if (response != null) {
                        observer.next(response);
                        observer.complete();
                    }
                },
                error => {
                    observer.next(error);
                    observer.complete();
                },
                () => {
                });
        });
    }
    
    public getsupervisorLoginResponseData(username, password, companyId) {
        return Observable.create((observer: Observer<any>) => {
            let headers = new Headers();
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            // headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));            
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_ORIGIN, "*, Content-Type");
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_HEADERS, 'Origin, Content-Type, X-Auth-Token');
            let options = new RequestOptions({
                headers: headers
            });
            let url = this.commonurl + "supervisorLogin";
            this.http.post(url, JSON.stringify({
                request: {
                    username: username,
                    password: password,
                    company_id: companyId,
                    user_type: "webuser",
                    number_of_days:90,
                    report_type: "Report"
            
                }
            }), options).timeout(this.timeout).subscribe(
                response => {
                    if (response != null) {
                        this.cookieService.setCookieData(Constant.KEY_USERNAME, username);
                       // this.cookieService.setCookieData(Constant.KEY_TOKEN, response.json().response.data.token);
                        this.localStorage.setItem(Constant.KEY_SUPERVISORLOGIN, response).subscribe(res => {
                            observer.next(response);
                            observer.complete();
                        });
                    }
                },
                error => {
                    observer.next(error);
                    observer.complete();
                },
                () => {
                });
        });
    }
    public getsupervisorLoginResponseData1(selectType) {
        return Observable.create((observer: Observer<any>) => {
            let headers = new Headers();
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            // headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));            
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_ORIGIN, "*, Content-Type");
            headers.append(Constant.HEADER_ACCESS_CONTROL_ALLOW_HEADERS, 'Origin, Content-Type, X-Auth-Token');
            let options = new RequestOptions({
                headers: headers
            });
            let url = this.commonurl + "supervisorLogin";
            this.http.post(url, JSON.stringify({
                request: {
                    username:this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    password: this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    company_id: "N",
                    user_type: "webuser",
                    number_of_days: selectType == 2 ? 0 : 90,
                    report_type: selectType == 2 ? "Live" : "Report"
            
                }
            }), options).timeout(this.timeout).subscribe(
                response => {
                    if (response != null) {
                       // console.log("select type"+JSON.stringify(response));
                        this.cookieService.getCookieData(Constant.KEY_USERNAME);
                       // this.cookieService.setCookieData(Constant.KEY_TOKEN, response.json().response.data.token);
                       response = response.json()
                       this.localStorage.setItem(Constant.KEY_SUPERVISORLOGIN, response).subscribe(res => {
                            observer.next(response);
                            observer.complete();
                        });
                    }
                },
                error => {
                    observer.next(error);
                    observer.complete();
                },
                () => {
                });
        });
    }

    language_key = Constant.KEY_CDISELECTEDLANGUAGE;

    getTopSellingProducts() {
        return Observable.create((observer: Observer<any>) => {

            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");

            let options = new RequestOptions({
                headers: headers
            });

            let url = this.commonurl + "recommendedproducts";
            this.http.post(url, JSON.stringify({
                request: {

                    "cust-number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    // "fetch_criteria": "week",
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME)
                }
            }), options).timeout(this.timeout).subscribe(
                res => {
                    if (res.json().response.status_code == 200) {
                        if (res.json().response.error_message === '') {
                            this.localStorage.setItem(Constant.KEY_TOPSELLINGITEM, res.json()).subscribe(data => {
                                observer.next(res.json());
                                observer.complete();
                            });
                        } else if (res.json().response.error_message !== '') {
                            observer.next(res.json());
                            observer.complete();

                        }
                        else {
                            this.localStorage.getItem(Constant.KEY_TOPSELLINGITEM).subscribe(result => {
                                if (result != null) {
                                    observer.next(result);
                                    observer.complete();
                                } else {
                                    observer.error(error);
                                    observer.complete();

                                }
                            });
                        }

                    }
                    else {
                        observer.next(res.json())
                        observer.complete();

                    }


                    // else {
                    //     this.localStorage.getItem(Constant.KEY_TOPSELLINGITEM).subscribe(result => {
                    //         if (result != null) {
                    //             observer.next(result);
                    //             observer.complete();
                    //         } else {
                    //             observer.error(error);
                    //             observer.complete();

                    //         }
                    //     });
                    // }
                },
                error => {
                    this.localStorage.getItem(Constant.KEY_TOPSELLINGITEM).subscribe(result => {
                        if (result != null) {
                            observer.next(result);
                            observer.complete();
                        } else {
                            observer.error(error);
                            observer.complete();

                        }
                    });
                },
                () => {

                });
        });
    }
    getCategoriesData() {
        return Observable.create((observer: Observer<any>) => {

            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");


            let options = new RequestOptions({
                headers: headers
            });

            let url = this.commonurl + "categories";
            this.http.post(url, JSON.stringify({
                request: {
                    "category_id": "*",
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME)

                }


            }), options).timeout(this.timeout).subscribe(
                res => {
                    if (res.json().response.status_code === 200 &&
                        res.json().response.error_message === '') {

                        let categories = res.json().response.data.categories;
                        this.localStorage.setItem(Constant.KEY_FILTERDATA, categories).subscribe(data => {
                            observer.next(categories);
                            observer.complete();
                        });
                    }
                    else {
                        this.localStorage.getItem(Constant.KEY_FILTERDATA).subscribe(result => {
                            if (result != null) {
                                observer.next(result);
                                observer.complete();
                            } else {
                                observer.error(error);
                                observer.complete();
                            }
                        });
                    }
                },
                error => {
                    this.localStorage.getItem(Constant.KEY_FILTERDATA).subscribe(result => {
                        if (result != null) {
                            observer.next(result);
                            observer.complete();
                        } else {
                            observer.error(error);
                            observer.complete();
                        }
                    });
                },
                () => {

                });
        });
    }

    changeSelectedCategory(category) {
        this.categoryItem = category;
        this.selectedCategorySource.next(category);
    }


    changeSelectedorder(order) {
        if (order) {
            this.orderItem = order;
            this.selectedOrderSource.next(order);
        }
    }

    changeSearchedProducts(search: string) {
        this.searchTerm = search;
        this.selectedproductsearch.next(search);
    }

    getCategoryProducts(category, unique_id) {

        let lastSync = this.cookieService.getCookieData(Constant.KEY_LASTSYNCTIMESTAMP);
        if (this.cookieService.getCookieData(Constant.KEY_LASTSYNCTIMESTAMP) === '') {
            lastSync = new Date().getMilliseconds().toString();
        }
        return Observable.create((observer: Observer<any>) => {

            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");

            let options = new RequestOptions({
                headers: headers
            });

            let url = this.commonurl + "itemspagination";
            this.http.post(url, JSON.stringify({
                request: {
                    "category_id": category,
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "unique_id":unique_id
                    //"last_sync_timestamp": Number.parseInt(lastSync)
                }
            }), options).timeout(this.timeout).subscribe(res => {

                observer.next(res.json());
                observer.complete();

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }


    getSearchedProducts(search: string) {
        let searchItems = [];
        this.selectedproductsearch.next(search);
        return searchItems;
    }

    getAllSearchProducts(search: string) {
        return Observable.create((observer: Observer<any>) => {

            if (search === '') {
                observer.next(undefined);
                observer.complete();
            } else {
                this.localStorage.setItem(Constant.KEY_SEARCH, search).subscribe(data => {
                });
                let headers = new Headers();
                //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
                headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
                headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
                headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");

                let options = new RequestOptions({
                    headers: headers
                });

                let url = this.commonurl + "productsearch";

                this.http.post(url, JSON.stringify({
                    request: {
                        "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                        "search_keyword": search
                    }
                }), options).timeout(50000).subscribe(res => {
                    var results = res.json();
                    if (results.response.status_code === 200) {

                        if (res.json().response.total_results_found === 0) {
                            let error = {};
                            error['status'] = results.response.status_code;
                            error['error_message'] = results.response.error_message;
                            observer.error(error);
                            observer.complete();
                        }

                        this.localStorage.setItem(Constant.KEY_SEARCHRESULTS, res.json().response.search_result).subscribe(response => {

                            observer.next(res.json().response.search_result);
                            observer.complete();
                        });
                    }

                }, (error: Response) => {
                    observer.error(error);
                    observer.complete();
                })
            }
        });
    }

    logout() {

        return Observable.create((observer: Observer<any>) => {
            let url = this.commonurl + 'logout';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");

            let options = new RequestOptions({
                headers: headers
            });

            this.http.post(url, JSON.stringify({
                request: {
                    "token": this.cookieService.getCookieData(Constant.KEY_TOKEN)
                }
            }), options).subscribe(response => {

                let res = response.json();
                console.log("result"+JSON.stringify(res));
                if (res.status_code != 200 && res.response.status === "Success") {
                    observer.next(true);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.response.status_code;
                    error['error_message'] = res.response.error_message;
                    observer.error(error);
                    observer.complete();
                }
            }, error => {
                observer.error(error);
                observer.complete();
            });
        });
    }

    addCartItem(product) {
        let items = [];
        // let cProduct = Object.assign({}, product);
        let dProduct = {};
        dProduct["item_number"] = product.item_number;
        dProduct["description"] = product.description
        dProduct["quantity"] = product.quantity
        dProduct["unit_price"] = product.unit_price
        dProduct["item_color"] = product.item_color
        dProduct["item_size"] = product.item_size
        dProduct["unique_id"] = product.unique_id
        // delete cProduct["pictures"];
        // delete cProduct["more_product_data"];
        // delete cProduct["pdf_link"];
        // delete cProduct['item_tax_unit'];
        // delete cProduct['class_code'];
        // delete cProduct['qty_on_hand'];
        // delete cProduct['price'];
        // delete cProduct['no_of_times_purchased'];

        items.push(dProduct);
        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'cart';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });
            let rBody = JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "action": "a",
                    "cust_number": "",
                    "cart_data": { "ttCartProducts": items }
                }

            });

            this.http.post(url, rBody, options).subscribe(response => {
                let res = response.json().response;
                if (res.status_code == 200) {
                    observer.next(res.records_identifier);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.status_code;
                    error['error_message'] = res.error_message;
                    observer.error(error);
                    observer.complete();
                }

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }


    modifyCartItems(modifiedData) {
        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'cart';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });

            this.http.post(url, JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "action": "m",
                    "cust_number": "",
                    "cart_data": { "ttCartProducts": [modifiedData] }
                }
            }), options).subscribe(response => {
                let res = response.json().response;
                if (res.status_code == 200) {
                    observer.next(res.records_identifier);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.status_code;
                    error['error_message'] = res.error_message;
                    observer.error(error);
                    observer.complete();
                }

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }

    removeCartItems(product) {



        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'cart';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });
            // let unique_value=product.item_number+product.item_color+product.item_size
            let rBody = JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "action": "r",
                    "cust_number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cart_data": { "ttCartProducts": [{ "unique_id": product.unique_id }] }
                }
            });
            this.http.post(url, rBody, options).subscribe(response => {
                let res = response.json().response;
                if (res.status_code == 200) {
                    observer.next(res.records_identifier);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.status_code;
                    error['error_message'] = res.error_message;
                    observer.error(error);
                    observer.complete();
                }

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }

    emptyCartItems() {

        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'cart';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });

            this.http.post(url, JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "action": "e",
                    "cust_number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cart_data": { "ttCartProducts": [] }
                }
            }), options).subscribe(response => {
                let res = response.json().response;
                if (res.status_code == 200) {
                    observer.next(res.records_identifier);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.status_code;
                    error['error_message'] = res.error_message;
                    observer.error(error);
                    observer.complete();
                }

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }
    getcartproducts() {
        let lastSync = this.cookieService.getCookieData(Constant.KEY_LASTSYNCTIMESTAMP);
        if (lastSync === '') {
            lastSync = new Date().getMilliseconds().toString();
        }
        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'getcartproducts';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });

            this.http.post(url, JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cust-number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "last_sync_timestamp": lastSync
                }
            }), options).timeout(this.timeout).subscribe(response => {
                let res = response.json().response;
                if (res.error_message === "") {
                    this.cookieService.setCookieData(Constant.KEY_LANGUAGE, lastSync);
                    observer.next(res.in_cart_products);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.status_code;
                    error['error_message'] = res.error_message;
                    observer.error(error);
                    observer.complete();
                }

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }


    getcheckoutdata(requestBody) {
        let lastSync = this.cookieService.getCookieData(Constant.KEY_LASTSYNCTIMESTAMP);
        if (lastSync === '') {
            lastSync = new Date().getMilliseconds().toString();
        }
        return Observable.create((observer: Observer<any>) => {
            let url = this.commonurl + 'checkout';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            let options = new RequestOptions({
                headers: headers
            });
            this.http.post(url, JSON.stringify(requestBody),
                options).timeout(this.timeout).subscribe(response => {
                    let res = response.json().response;
                    if (res.status_code == 200) {
                        this.cookieService.setCookieData(Constant.KEY_LANGUAGE, lastSync);
                        observer.next(res);
                        observer.complete();
                    }

                    else {
                        let error = {};
                        error['status'] = res.status_code;
                        error['error_message'] = res.error_message;
                        observer.error(error);
                        observer.complete();
                    }

                }, error => {
                    observer.error(error);
                    observer.complete();
                });

        });
    }

    getorderList(timeSpan) {
        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'orderhistory';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });
            this.http.post(url, JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cust-number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "no_of_months": timeSpan,
                    "last_sync_timestamp": '0'
                }
            }), options).timeout(this.timeout).subscribe(res => {
                if (res.json().response.status_code === 200) {
                    if (res.json().response.error_message === '') {
                        let orderdata = res.json().response.orders_history;
                        // this.localStorage.setItem(Constant.KEY_ORDERDATA, orderdata).subscribe(res => {
                        observer.next(res);
                        observer.complete();
                        // });
                    }
                    else {
                        let orderdata = res.json().response.orders_history;
                        // this.localStorage.setItem(Constant.KEY_ORDERDATA, orderdata).subscribe(data => {
                        observer.next(res);
                        observer.complete();
                        // });
                    }
                    // else{
                    //     let orderdata = res.json().response.orders_history;
                    //     observer.next(orderdata);
                    //    observer.complete();
                    // }
                }
                else {
                    // this.localStorage.getItem(Constant.KEY_ORDERDATA).subscribe(result => {
                    // if (res != null) {
                    observer.error(res);
                    observer.complete();
                    // } else {
                    // observer.error(res);
                    // observer.complete();
                }
                // });
                // }
            },
                error => {
                    this.localStorage.getItem(Constant.KEY_ORDERDATA).subscribe(result => {
                        if (result != null) {
                            observer.next(result);
                            observer.complete();
                        } else {
                            observer.error(error);
                            observer.complete();
                        }
                    });
                },
                () => {

                });
        });
    }

    getordereditems(order) {

        return Observable.create((observer: Observer<any>) => {

            let url = this.commonurl + 'ordereditems';
            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.userid + ":" + this.password));
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));

            let options = new RequestOptions({
                headers: headers
            });

            this.http.post(url, JSON.stringify({
                request: {
                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cust-number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "order_number": order
                }
            }), options).timeout(this.timeout).subscribe(response => {
                let res = response.json().response;
                if (res.status_code == 200) {
                    //this.cookieService.setCookieData(Constant.KEY_LANGUAGE, lastSync);
                    observer.next(res.ordered_items);
                    observer.complete();
                }
                else {
                    let error = {};
                    error['status'] = res.status_code;
                    error['error_message'] = res.error_message;
                    observer.error(error);
                    observer.complete();
                }

            }, error => {
                observer.error(error);
                observer.complete();
            });

        });
    }

    getInvoiceDetail(invoice_number) {
        return Observable.create((observer: Observer<any>) => {

            let headers = new Headers();
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            let options = new RequestOptions({
                headers: headers
            });

            let url = this.commonurl + "invoicedetail";
            this.http.post(url, JSON.stringify({
                request: {

                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cust-number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "invoice_number": invoice_number
                }
            }), options).timeout(this.timeout).subscribe(
                res => {
                    if (res.json().response.status_code == 200) {
                        if (res.json().response.error_message === '') {
                            observer.next(res.json());
                            observer.complete();
                        } else if (res.json().response.error_message !== '') {
                            observer.next(res.json());
                            observer.complete();
                        }

                    }
                    else {
                        observer.next(res.json())
                        observer.complete();
                    }
                },
                error => {
                    this.localStorage.getItem(Constant.KEY_INVOICEDATA).subscribe(result => {
                        if (result != null) {
                            observer.next(result);
                            observer.complete();
                        } else {
                            observer.error(error);
                            observer.complete();

                        }
                    });
                },
                () => {

                });
        });
    }

    getinvoicehistory() {
        return Observable.create((observer: Observer<any>) => {

            let headers = new Headers();
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            let options = new RequestOptions({
                headers: headers
            });

            let url = this.commonurl + "invoicehistory";
            this.http.post(url, JSON.stringify({
                request: {

                    "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "cust-number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                    "last_sync_timestamp": 0
                }
            }), options).timeout(this.timeout).subscribe(
                res => {
                    if (res.json().response.status_code == 200) {
                        if (res.json().response.error_message === '') {
                            this.localStorage.setItem(Constant.KEY_INVOICEDATA, res.json()).subscribe(data => {
                                observer.next(res.json());
                                observer.complete();
                            });
                        } else if (res.json().response.error_message !== '') {
                            observer.next(res.json());
                            observer.complete();

                        }
                        else {
                            this.localStorage.getItem(Constant.KEY_INVOICEDATA).subscribe(result => {
                                if (result != null) {
                                    observer.next(result);
                                    observer.complete();
                                } else {
                                    observer.error(error);
                                    observer.complete();

                                }
                            });
                        }

                    }
                    else {
                        observer.next(res.json())
                        observer.complete();

                    }
                },
                error => {
                    this.localStorage.getItem(Constant.KEY_INVOICEDATA).subscribe(result => {
                        if (result != null) {
                            observer.next(result);
                            observer.complete();
                        } else {
                            observer.error(error);
                            observer.complete();

                        }
                    });
                },
                () => {

                });
        });
    }

    collectTotalPayment(requestData) {
        return Observable.create((observer: Observer<any>) => {
            let headers = new Headers();
            headers.append(Constant.HEADER_LANG_ID, this.cookieService.getCookieData(this.language_key));
            headers.append(Constant.HEADER_CONTENT_TYPE, "application/json");
            headers.append(Constant.HEADER_TOKEN, this.cookieService.getCookieData(Constant.KEY_TOKEN));
            let options = new RequestOptions({
                headers: headers
            });
        //    let  request= {
        //         "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
        //         "cust_number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
        //         "payment_data": requestData
        //     }

            let url = this.commonurl + 'collectpayment';
            this.http.post(url, JSON.stringify({
               request: {
                "username": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                "cust_number": this.cookieService.getCookieData(Constant.KEY_USERNAME),
                "payment_data": requestData
            }  }), options).timeout(this.timeout).subscribe(
                res => {
                    if (res != null) {
                        observer.next(res);
                        observer.complete();
                    }
                },
                error => {
                }
                )
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/providers/rest.service.ts